<div class="component-container">
  <h2
    class="title"
    [style]="{
      color: config().title.color,
      fontFamily: config().title.fontFamily,
    }"
    [innerHTML]="config().title.text"
  ></h2>
  <p
    class="subtitle"
    [style]="{
      color: config().subtitle.color,
      fontFamily: config().subtitle.fontFamily,
    }"
  >
    {{ config().subtitle.text }}
  </p>

  <div class="contact-block">
    @let description = config().contactFormBlock.description;
    @if (description) {
      <p
        class="description"
        [style]="{
          color: description.color,
          fontFamily: description.fontFamily,
        }"
      >
        {{ description.text }}
      </p>
    }

    <form [formGroup]="form" class="form-wrapper">
      @for (item of config().contactFormBlock.fields; track $index) {
        @switch (item.type) {
          @case (FormFieldType.TEXT || FormFieldType.EMAIL) {
            <b2c-input
              [type]="item.type"
              [label]="item.label || ''"
              [labelStyles]="item.labelStyles!"
              [errorStyles]="item.errorStyles!"
              [placeholder]="item.placeholder"
              [attr.data-cy]="item.formControlName"
              [formControlName]="item.formControlName"
              [errorMessages]="controlErrorMessages[item.formControlName]"
              [autoComplete]="item.autoComplete || ''"
              [required]="item.required || false"
            />
          }
          @case (FormFieldType.SELECT) {
            <b2c-select
              [label]="item.label || ''"
              [options]="item.options || []"
              [labelStyles]="item.labelStyles!"
              [placeholder]="item.placeholder"
              [attr.data-cy]="item.formControlName"
              [formControlName]="item.formControlName"
              [errorMessages]="controlErrorMessages[item.formControlName]"
              (ngModelChange)="onValueChanged($event, item.formControlName)"
              [required]="item.required || false"
            />
          }
        }
      }

      <p id="contact-message-label" class="text-area-label">
        {{ config().contactFormBlock.textAreaLabel }}
      </p>
      <div
        role="textbox"
        class="text-area"
        [class.showing-example]="!form.value.content"
        aria-labelledby="contact-message-label"
        contenteditable="true"
        aria-multiline="true"
        (input)="onContentChanged($event)"
        [innerHTML]="textAreaMessages[selectedOption] | safe"
      ></div>
      @if (successMessage().length || errorMessage().length) {
        <div class="response-msg">
          @if (errorMessage().length) {
            <div class="error">
              {{ errorMessage() }}
            </div>
          }
          @if (successMessage().length) {
            <div class="success">
              {{ successMessage() }}
            </div>
          }
        </div>
      }

      @let submitButton = config().contactFormBlock.submitButton;
      <b2c-button
        class="submit-btn"
        (click)="submit()"
        buttonType="submit"
        cssClass="submit-btn-pill"
        [disabled]="form.invalid || submitted()"
        [class.disabled]="form.invalid || submitted()"
      >
        {{ submitButton.label }}
        <img alt="" [src]="submitButton.iconUrl" />
      </b2c-button>
    </form>
  </div>
</div>
